import { render, staticRenderFns } from "./orders-view.vue?vue&type=template&id=53f4cf2d"
import script from "./orders-view.vue?vue&type=script&lang=js"
export * from "./orders-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports